<template>
    <div class="print-modelDetail">
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" class="button-view" icon="el-icon-printer" @click.stop="print()">打印</el-button>
            <el-button size="mini" class="button-view" icon="el-icon-printer" @click.stop="createPdf()" >导出打印</el-button>
            <el-button size="mini" class="button-view" icon="el-icon-tickets" style="margin-right:20px;" @click="closeApproval" v-if="formInfo.approvalRecordList && formInfo.approvalRecordList.length>0 && !isTempatePrint">{{btnText}}</el-button>
        </span>
        <div class="model-content" :id="`printId`">
            <el-form :model="formInfo.values" :ref="formInfo" label-width="165px"  v-if="isTempatePrint">
                <div style="text-align: center; font-size: large; margin-bottom: 15px;" >{{formInfo.formName}}</div>
                <template v-if="isTempatePrint">
                    <p v-html="printTemplateContent"></p>
                    <!-- <p style="margin-top: 15px;" v-if='isTempatePrintApproval' v-html="formInfo.printTemplateApproval"></p> -->
                </template>
            </el-form>
            <template v-else>
                <!-- <FieldItem v-for="(field,index2) in formInfo.fieldsList" :isPrintPage="isPrintPage" :findex="index2" ref="fieldItemChild" :formId="formInfo.id" :key="field.fieldId" :field="field" :formData="formInfo.values" :colSpan="formInfo.colSpan" :isRead="isRead" :fieldsList="formInfo.fieldsList"/> -->
                <PrintFormHtml :formInfo="formInfo" :showApprovalInfo="showApprovalInfo" ref="printFormHtml"></PrintFormHtml>
            </template>
            <div v-if="isShowApproval && formInfo.approvalRecordList" style="width:340mm;margin-top: 30mm;padding-left: 25mm;">
                <el-table :data="formInfo.approvalRecordList" :border="true" style="width:340mm;margin-top: 30mm;">
                    <el-table-column
                    type="index"
                    width="30">
                    </el-table-column>
                    <el-table-column
                        label="审批人"
                        prop="trueName"
                        :show-overflow-tooltip="true"
                        align="center"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        label="审批状态"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <el-button size="mini" v-if="scope.row.approvalResult==0" round>未处理</el-button>
                            <el-button size="mini" v-if="scope.row.approvalResult==1" round>通过</el-button>
                            <el-button size="mini" v-if="scope.row.approvalResult==2" round>驳回</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="审批时间"
                        align="center"
                        prop="approvalDate"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        label="审批意见"
                        align="center"
                        :show-overflow-tooltip="true"
                        prop="approvalRemarks"
                        width="1000"
                        >
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import printJS from 'print-js';
    import PrintFormHtml from './PrintFormHtml';
    import { isEmpty } from 'lodash';

    export default {
        components: {
            PrintFormHtml: PrintFormHtml
        },
        data () {
            return {
                printTemplateContent: '',
                isTempatePrintApproval: false,
                isPrintPage: true,
                isRead: true,
                showApprovalInfo: true,
                btnText: '关闭审批流',
                pdfTitle: this.formInfo.formName, // 填入导出的pdf文件名和html元素
                pdfSelector: '#printId' // 填入导出的html元素
            };
        },
        props: {
            formInfo: {
                type: Object
            },
            isShowApproval: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            isTempatePrint () { // 是否是按照模板打印
                this.printTemplateContent = '';
                if (this.formInfo && this.formInfo.hasOwnProperty('printTemplate')) {
                    if (isEmpty(this.formInfo.printTemplate)) {
                        return false;
                    } else {
                        // 循环遍历审批记录，拼接HTML
                        if (this.formInfo.approvalRecordList && this.formInfo.approvalRecordList.length > 0) {
                            let approvalDetailTable = '<table border="1" width="100%" cellpadding="0" cellspacing="0"><tbody><tr><th colspan="4">审批详情</th></tr><tr><td width="80px;">#</td><td  width="240px;">审批人</td><td  width="120px;">审批状态</td><td>审批意见</td></tr>';
                            for (let i = 0; i < this.formInfo.approvalRecordList.length; i++) {
                                let item = this.formInfo.approvalRecordList[i];
                                let approvalList = item.list;
                                let trueNameArray = [];
                                let resultArray = [];
                                let remarksArray = [];
                                if (approvalList && approvalList.length > 0) {
                                    for (let j = 0; j < approvalList.length; j++) {
                                        let cur = approvalList[j];
                                        trueNameArray.push(cur.trueName);
                                        if (cur.approvalResult === 0) {
                                            resultArray.push('未处理');
                                        } else if (cur.approvalResult === 1) {
                                            resultArray.push('通过');
                                        } else if (cur.approvalResult === 2) {
                                            resultArray.push('驳回');
                                        }
                                        if (cur.approvalRemarks === undefined) {
                                            cur.approvalRemarks = '';
                                        }
                                        if (cur.approvalDate === undefined) {
                                            cur.approvalDate = '';
                                        }
                                        remarksArray.push(cur.approvalRemarks + ' ' + cur.approvalDate);
                                    }
                                } else {
                                    trueNameArray.push(item.trueName);
                                    if (item.approvalResult === 0) {
                                        resultArray.push('未处理');
                                    } else if (item.approvalResult === 1) {
                                        resultArray.push('通过');
                                    } else if (item.approvalResult === 2) {
                                        resultArray.push('驳回');
                                    }
                                    if (item.approvalRemarks === undefined) {
                                        item.approvalRemarks = '';
                                    }
                                    if (item.approvalDate === undefined) {
                                        item.approvalDate = '';
                                    }
                                    remarksArray.push(item.approvalRemarks + ' ' + item.approvalDate);
                                }
                                approvalDetailTable = approvalDetailTable + '<tr><td>' + (i + 1) + '审</td><td>' + trueNameArray.join(',') + '</td><td>' + resultArray.join(',') + '</td><td>' + remarksArray.join('|') + '</td></tr>';
                            }
                            approvalDetailTable = approvalDetailTable + '</tbody></table></br>';
                            // this.formInfo.printTemplateApproval = approvalDetailTable;
                            this.printTemplateContent = this.formInfo.printTemplate + approvalDetailTable;
                            // this.isTempatePrintApproval = true;
                            // console.log(this.formInfo.printTemplateApproval);
                        } else {
                            this.printTemplateContent = this.formInfo.printTemplate;
                        }
                        return true;
                    }
                } else {
                    return false;
                }
            }
        },
        created () {
            this._initData();
        },
        methods: {
            _initData () {
                // console.log("打印");
                // console.log(this.formInfo);
            },
            print () {
                // const style = '@page { margin: 0 } @media print {}';// 自定义样式
                printJS({
                    printable: 'printId', // 要打印内容的id
                    type: 'html',
                    documentTitle: '',
                    targetStyles: ['*'] // 继承原来的所有样式
                    // scanStyles: true,
                    // ignoreElements: ['.el-table'],
                    // style: 'table tr td,th { border-collapse: collapse;padding: 15px;border:1px #000 solid; }'
                });
            },
            closeApproval () {
                if (this.showApprovalInfo) {
                    this.showApprovalInfo = false;
                    this.btnText = '显示审批流';
                } else {
                    this.showApprovalInfo = true;
                    this.btnText = '关闭审批流';
                }
                if (this.$refs.printFormHtml) {
                    this.$refs.printFormHtml.showApprovalRecord();
                }
            },
            async createPdf () {
                this.$confirm(`导出pdf文件需要您耐心等待大概5~10秒时间,期间请勿重复点击导出按钮。`, '提示', {
                    confirmButtonText: '确定导出',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    this.getPdf('#printId');
                }).catch(() => {});
            }
        }
    };
</script>
 <!-- <style lang="less" scoped> -->
<style lang="less">
    @page {
        /* size: auto; //默认的*/
        size: A4 landscape; // portrait/landscape //使用系统中的纸张和方向
        margin: 3mm;//打印文档的边距设置
        margin-right:3mm;
        table{
            page-break-after: avoid;//避免表格断开
            page-break-inside: avoid;//避免某行文字断裂
        }
    }
    .print-modelDetail {
        width: 98%;
        height: 90%;
        margin-top: -3%;
        text-align: center;
        // overflow-y: auto;
        .model-content {
            padding: 10px;
            width:380mm;//打印需要设置单位为mm，否则无法打印多列情况
            flex: 1;
            display:inline-block;
            flex-direction: row;
            .el-form-item__label{
              color: #333;
              font-weight: 700;
            }
            .content-left {
              width: 100%;
              // margin: 0 15px 0 0;
              .el-card__body{
                padding: 0px
              }
            }
            .form-title {
                text-align: center;
                font-size: large;
                margin-bottom: 15px;
            }
            .el-table--scrollable-x .el-table__body-wrapper{//打印确认页的滚动取消
                overflow-x: hidden;
            }
            table {
                border-top: 1px solid #999;
                border-left: 1px solid #999;
                border-spacing: 0;/*去掉单元格间隙*/
                td,th{
                   border-bottom: 1px solid #999;
                   border-right: 1px solid #999;
                   text-align: left;
                   padding: 2px 4px;
                }
            }
        }
        .button-view {
            float:right;
        }
        .el-input.is-disabled .el-input__inner {
          color: #606266;
        }
        .el-textarea.is-disabled .el-textarea__inner{
           color: #606266;
        }
        .render-form-item {
            .el-input--small .el-input__inner {
                margin-top: 0px;
            }
          }
    }
</style>



// WEBPACK FOOTER //
// src/components/PrintUtil/PrintUtil.vue